export default __webpack_public_path__ + "static/media/merkur-logo-icon.d5145670.svg";